import React from "react";
import { useUID } from "react-uid";

export default function Euro({ color, size }) {
  const id = useUID();
  const svgSize = size === "sm" ? 11 : 22;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={svgSize}
      height={svgSize}
      viewBox="0 0 22 22"
    >
      <defs>
        <path
          id={id}
          d="M11 20c-4.962 0-9-4.037-9-9 0-4.962 4.038-9 9-9 4.963 0 9 4.038 9 9 0 4.963-4.037 9-9 9M0 11c0 6.065 4.935 11 11 11s11-4.935 11-11S17.065 0 11 0 0 4.935 0 11z"
        />
      </defs>
      <g fill={color} fillRule="evenodd">
        <path
          fillRule="nonzero"
          d="M13.577 14.925a3.19 3.19 0 0 1-1.827.575c-1.381 0-2.579-.912-3.228-2.25H11a.75.75 0 0 0 0-1.5H8.063A5.343 5.343 0 0 1 8 11c0-.256.029-.505.063-.75h3.687a.75.75 0 0 0 0-1.5H8.522c.65-1.338 1.847-2.25 3.228-2.25a3.19 3.19 0 0 1 1.827.575.75.75 0 1 0 .846-1.24A4.733 4.733 0 0 0 11.75 5C9.553 5 7.671 6.556 6.89 8.75H5.75a.75.75 0 0 0 0 1.5h.816c-.027.249-.066.494-.066.75s.039.501.066.75H5.75a.75.75 0 0 0 0 1.5h1.14C7.672 15.444 9.553 17 11.75 17c.948 0 1.872-.29 2.673-.835a.75.75 0 1 0-.846-1.24z"
        />
        <use xlinkHref={`#${id}`} />
      </g>
    </svg>
  );
}
